import React from 'react';

import PaymentArrangementRequest from '../../paymentArrangement/PaymentArrangementRequest';

export const PaymentArrangementRequestScreen = () => {
  return (
    <PaymentArrangementRequest/>
  );
}

export default PaymentArrangementRequestScreen;
